import { render, staticRenderFns } from "./ContScoreCard.vue?vue&type=template&id=ab83ffb6&"
import script from "./ContScoreCard.vue?vue&type=script&lang=js&"
export * from "./ContScoreCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports